import angular from 'angular';

/**
 * Directiva para elegir un rango de fechas
 */
rangeDatePicker.$inject = ['lang', '$timeout'];
export default function rangeDatePicker(lang, $timeout) {
    var textos = {
        es: {
            texto_defecto: 'rango de fechas...',
            hoy: 'Hoy',
            ayer: 'Ayer',
            ultimos_7_dias: 'Últimos 7 días',
            ultima_semana: 'Última semana (Lu a Do)',
            mes_hasta_hoy: 'Mes hasta hoy',
            anyo_hasta_hoy: 'Año hasta hoy',
            mes_pasado: 'Mes pasado',
            hasta: ' hasta ',
            limpiar: 'Limpiar',
            cancelar: 'Cancelar',
            seleccionar: 'Seleccionar'
        },
        ca: {
            texto_defecto: 'rang de dates...',
            hoy: 'Hui',
            ayer: 'Ahir',
            ultimos_7_dias: 'Últims 7 dies',
            ultima_semana: 'Última setmana (Di a Diu)',
            mes_hasta_hoy: 'Mes fins hui',
            anyo_hasta_hoy: 'Any fins hui',
            mes_pasado: 'Mes passat',
            hasta: ' fins ',
            limpiar: 'Netejar',
            cancelar: "Cancel·lar",
            seleccionar: 'Seleccionar'
        }
    };
    return {
        restrict: 'AE',
        scope: {
            texto: '=',
            ngModel: '=',
            ngChange: '&'
        },
        link: function (scope, element, attrs, ngModelCtrl) {
            var texto = attrs.texto ? attrs.texto : textos[lang].texto_defecto;
            $(function () {
                //console.log(ngModelCtrl);
                scope.$evalAsync(function () {
                    element.daterangepicker({
                        datepickerOptions: {
                            numberOfMonths: 2
                        },
                        presetRanges: [
                            {
                                text: textos[lang].hoy,
                                dateStart: function () {
                                    return moment()
                                },
                                dateEnd: function () {
                                    return moment()
                                }
                            },
                            {
                                text: textos[lang].ayer,
                                dateStart: function () {
                                    return moment().subtract('days', 1)
                                }, dateEnd: function () {
                                    return moment().subtract('days', 1)
                                }
                            },
                            {
                                text: textos[lang].ultimos_7_dias, dateStart: function () {
                                    return moment().subtract('days', 6)
                                }, dateEnd: function () {
                                    return moment()
                                }
                            },
                            {
                                text: textos[lang].ultima_semana, dateStart: function () {
                                    return moment().subtract('days', 7).isoWeekday(1)
                                }, dateEnd: function () {
                                    return moment().subtract('days', 7).isoWeekday(7)
                                }
                            },
                            {
                                text: textos[lang].mes_hasta_hoy, dateStart: function () {
                                    return moment().startOf('month')
                                }, dateEnd: function () {
                                    return moment()
                                }
                            },
                            {
                                text: textos[lang].mes_pasado, dateStart: function () {
                                    return moment().subtract('month', 1).startOf('month')
                                }, dateEnd: function () {
                                    return moment().subtract('month', 1).endOf('month')
                                }
                            },
                            {
                                text: textos[lang].anyo_hasta_hoy, dateStart: function () {
                                    return moment().startOf('year')
                                }, dateEnd: function () {
                                    return moment()
                                }
                            }
                        ],
                        applyOnMenuSelect: false,
                        initialText: texto,
                        //dateFormat: 'dd/mm/yy',
                        //altFormat: 'dd/mm/yy',
                        rangeSplitter: textos[lang].hasta,
                        clearButtonText: textos[lang].limpiar,
                        cancelButtonText: textos[lang].cancelar,
                        applyButtonText: textos[lang].seleccionar,
                        onChange: function () {
                            scope.$apply(function () {
                                var json = (element.val()) ? angular.fromJson(element.val()) : element.val();
                                scope.ngModel = json;

                                if (scope.ngChange) {
                                    $timeout(function () {
                                        scope.ngChange();
                                    })
                                }
                                //ngModelCtrl.$setViewValue(json);
                            });
                        },
                        onClose: function () {
                        },
                        onOpen: function () {
                        }
                    });

                    scope.$watch("ngModel", function (newValue, oldValue) {
                        if (typeof newValue === 'undefined') {
                            if (typeof element.val() !== 'undefined') {
                                element.daterangepicker("clearRange");
                            }
                        } else {
                            // TODO: Falta actualizar el valor, por si se quiere cambiar el modelo desde otro lado
                        }
                    });
                });

            });

        }
    }
}